import React, { useEffect, useState, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import { toast } from 'react-toastify';
import useManageWeeklyShip from '../weeklyShip/useManageWeeklyShip';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import IconButton from '@mui/material/IconButton';
import { formatDate } from '../../utils/dateUtils';
import OrderSummaryTable from '../../sharedComponents/OrderSummaryTable';
import { useAuth } from '../../context/AuthContext';
import TextField from '@mui/material/TextField';
import useShipDate from '../setting/shipDate/useShipDate';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircularProgress from '@mui/material/CircularProgress';
import useCollectMoney from '../collectMoney/useCollectMoney';
import useCustomerProfile from '../customerProfile/useCustomerProfile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LanguageIcon from '@mui/icons-material/Language';
import useManageOrder from '../order/useManageOrder';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { useSelector } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

// Hardcoded test users list - filter by shop
const TEST_USERS = [
  { name: 'Gain', socialId: 'U1234567890abcdef', shop: 'smile' },
  { name: 'Kluay', socialId: 'Uf9b41bfb00820904c5b39fdb0c186f15', shop: 'smile' },
  { name: 'Gain', socialId: 'U5ea06f0041d40c9a53d1702efffe253a', shop: 'tama' },
  { name: 'Kluay', socialId: 'Ub04bb976f780e7e449e4066b14448935', shop: 'tama' },
];

const Arrival = () => { 

  const IconComponent = (params) => {
    return (
      <>
        <IconButton onClick={() => handleInform(params.data.id, false)}>
          <DoubleArrowIcon style={{ color: "blue" }} />
        </IconButton>
      </>
    );
  };
  const IconComponentTotal = (params) => {
    return (
      <>
        <IconButton onClick={() => handleInform(params.data.id, true)}>
          <DoubleArrowIcon style={{ color: "blue" }} />
        </IconButton>
      </>
    );
  };
  const IconComponentBox = (params) => {
    return (
      <>
        <IconButton onClick={() => handleCopyBoxNo(params.data.CustomerProfile.id, true)}>
          <ContentCopyIcon style={{ color: "green" }} />
        </IconButton>
      </>
    );
  };

  const IconComponentUrl = (params) => {
    return (
      <>
        <IconButton onClick={() => handleCopyUrl(params.data.CustomerProfile.id, true)}>
          <LanguageIcon style={{ color: "green" }} />
        </IconButton>
      </>
    );
  };

  const IconComponentAddress = (params) => {
    return (
      <>
        <IconButton onClick={() => handleAddress(params.data.id)}>
          <CheckCircleIcon style={{ color: "blue" }} />
        </IconButton>
      </>
    );
  };

  const IconComponentSocialId = (params) => {
    if (!params.data || !params.data.CustomerProfile) {
      return null;
    }
    
    // Don't show Social ID icon for Facebook customers (Chatcone only supports LINE)
    const channel = params.data.CustomerProfile.channel;
    if (channel && channel.toLowerCase() === 'facebook') {
      return null;
    }
    
    const hasSocialId = params.data.CustomerProfile.socialId;
    return (
      <>
        <IconButton 
          onClick={() => handleSocialIdClick(params.data.CustomerProfile.id, params.data.CustomerProfile.socialId || '')} 
          title={hasSocialId ? "LINE Social ID มีอยู่ - คลิกเพื่อแก้ไข" : "ไม่มี LINE Social ID - คลิกเพื่อเพิ่ม (สำหรับส่งแจ้งเตือนผ่าน Chatcone)"}
        >
          {hasSocialId ? (
            <TaskAltIcon style={{ color: "#4caf50", fontSize: "1.5rem" }} />
          ) : (
            <RadioButtonUncheckedIcon style={{ color: "#9e9e9e", fontSize: "1.5rem" }} />
          )}
        </IconButton>
      </>
    );
  };

  const [rowData, setRowData] = useState([]);
  const [orders, setOrders] = useState({});
  const [orderSummary, setOrderSummary] = useState(null);
  const [isCompanyOrder, setIsCompanyOrder] = useState(false);
  const [profile, setProfile] = useState(null);
  const [sendSameAddress, setSendSameAddress] = useState(false)
  const [preRowData, setPreRowData] = useState([]);
  const [isArrival, setIsArrival] = useState(true)
  const [isDelay, setIsDelay] = useState(false)
  const [showTotal, setShowTotal] = useState(false)
  const [selectedState, setSelectedState] = useState('wait')
  const [shipDate, setShipDate] = useState(null)
  const [shipDateId, setShipDateId] = useState(null)
  const [textFieldValue, setTextFieldValue] = useState('')
  const [profileId, setProfileId] = useState('')
  const [profileIdUrl, setProfileIdUrl] = useState('')
  const [showCopiedMessage, setShowCopiedMessage] = useState(false);
  const [customerData, setCustomerData] = useState({})
  const {updateSendSameAddress, updateSocialId} = useCustomerProfile()
  const [socialIdDialogOpen, setSocialIdDialogOpen] = useState(false);
  const [currentSocialId, setCurrentSocialId] = useState('');
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const shopName = useSelector((state) => state.shop.name);

  const [columnDefs, setColumnDefs] = useState([
    { headerName: 'Contact', field: 'contact', flex: 2 },
    { headerName: 'Channel', field: 'channel', flex: 1 },
    { field: 'Social ID (LINE)', cellRenderer: IconComponentSocialId, flex: 1 },
    { field: 'ลิ้งค์สินค้า', cellRenderer: IconComponentUrl, flex : 1},
    { field: 'action', cellRenderer: IconComponent, flex : 1},
    { field: 'เลขกล่อง', cellRenderer: IconComponentBox, flex: 1 }

  ]);

  const highlightNeedDown = {
    backgroundColor: '#ff6e7f',
  };
  const highlightNeedCurrent = {
    backgroundColor: '#ffbe54', 
  };
  const highlightOldNotPaid = {
    backgroundColor: '#f9ff8f', 
  };
  const highlightSendSameAddress = {
    borderLeft: '8px solid #4caf50' // Thicker green left border (2x thicker)
  };

  // Sort function: white (normal) first, then yellow, then orange, then red
  const getSortPriority = (record) => {
    if (record.needDown) return 4; // Red - lowest priority (last)
    if (record.needCurrent) return 3; // Orange
    if (record.oldNotPaid) return 2; // Yellow
    return 1; // White/normal - highest priority (first)
  };

  const sortRecordsByPriority = (records) => {
    return [...records].sort((a, b) => {
      return getSortPriority(a) - getSortPriority(b);
    });
  };

  const { authState } = useAuth();
  const { user } = authState;

  const { shipDates, getShipDates } = useShipDate();
  const { getPersonOldNotPaidDataById } = useCollectMoney()
  const { getOrderUrl } = useManageOrder()

  const {
    isLoading,
    arrivalInform,
    getArrivalList,
    addDelayArrival,
    getBoxNoFromProfile,
    getArrivalPreview,
    sendArrivalNotifications,
    sendTestArrivalNotification
  } = useManageWeeklyShip()


  const onCellClicked = (params) => {
    if (params && params.data) {
      // Always set customerData when clicking any row, even if value is empty
      setCustomerData(params.data);
      
      // Only copy to clipboard if there's a value
      if (params.value) {
        navigator.clipboard.writeText(params.value).then(() => {
          toast.success(`${params.value} Copied!!`,{autoClose: 500})
        }).catch(err => {
          console.error('Failed to text: ', err);
        });
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if(customerData && shipDateId){
        const {customerId, oldNotPaid, needDown, needCurrent, contact, CustomerProfile} = customerData
        let status = 'normal'
        if(needDown){
          status = "needDown"
        }else if(needCurrent){
          status = "needCurrent"
        }else if(oldNotPaid){
          status = "oldNotPaid"
        }
        if(status != 'normal'){
          const response = await getPersonOldNotPaidDataById({customerId: customerId, shipDateId: shipDateId, status: status})
          setOrders(response.orders || [])
          setOrderSummary(response.summary || null)
          setIsCompanyOrder(response.isCompanyOrder || false)
          setProfile({customerId: customerId, contact: contact})
        }else{
          // For normal (white) rows, still set profile so button can be clicked
          setOrders([])
          setOrderSummary(null)
          setIsCompanyOrder(false)
          setProfile({customerId: customerId, contact: contact})
        }
        if(CustomerProfile && CustomerProfile.sendSameAddress){
          setSendSameAddress(true)
        }else{
          setSendSameAddress(false)
        }
      }
    }
    fetchData()
  },[customerData])

  const gridOptions = {
    onCellClicked: onCellClicked
  };
  
  const handleInform = async (arrivalId, showTotal) => {
    const result = await arrivalInform({arrivalId});
    if (result) {
      setRowData((prevRowData) => {
        if (!showTotal) {
          return prevRowData.filter((record) => record.id !== arrivalId);
        } else {
          return prevRowData.map((record) => {
            if (record.id === arrivalId) {
              const date = new Date();
              const dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
              return { ...record, informDate: formatDate(dateString) };
            }
            return record;
          });
        }
      });
    } else {
      toast.error("มีบางอย่างผิดพลาด!!"); 
    }
  };

  const handleAddress = async (arrivalId) => {
    const result = await arrivalInform({arrivalId, type: 'address'});
    if (result) {
      setRowData((prevRowData) => {
        return prevRowData.filter((record) => record.id !== arrivalId);
      });
    } else {
      toast.error("มีบางอย่างผิดพลาด!!"); 
    }
  };
  
  const handleCopyBoxNo = async (param) => {
    setProfileId(param)
  }

  const handleCopyUrl = async (param) => {
    setProfileIdUrl(param)
  }

  useEffect(() => {
    const fetchData = async () => {
      if(profileId && shipDate.length > 0){
        console.log(shipDate[0].id)
        const response = await getBoxNoFromProfile({customerId: profileId, shipDateId: shipDate[0].id})
        if (!Array.isArray(response)) {
          console.error('Expected an array response, received:', response);
          return; // Exit if the response is not an array
      }
        const boxNoArray = response.map(box => box.boxNo)
        const boxNoString = boxNoArray.join('|')
        const textToCopy = '=REGEXMATCH(TO_TEXT(I:I), "^(' + boxNoString + ')$")'
          navigator.clipboard.writeText(textToCopy)
            .then(() => {
              console.log('Text copied to clipboard');
              // Optionally set a state to show a confirmation message
              toast.success('Text copied!');
            })
            .catch(err => {
              console.error('Failed to copy text: ', err);
              toast.error('Failed to copy text');
            });
      }
    }
    fetchData()
  }, [profileId])

  useEffect(() => {
    const fetchData = async () => {
      if(profileIdUrl && shipDate.length > 0){
        console.log(shipDate[0].id)
        const response = await getOrderUrl({customerId: profileIdUrl, shipDateId: shipDate[0].id})
        if (!Array.isArray(response)) {
          console.error('Expected an array response, received:', response);
          return; // Exit if the response is not an array
      }
      const sendOnlyOrders = response.filter(order => order.isSendOnly);
      const normalOrders = response.filter(order => !order.isSendOnly);

      // Format the text for each group, only if there are items
      let textToCopy = '';

      if (sendOnlyOrders.length > 0 && normalOrders.length > 0) {
        // Case: Both groups exist
        const normalText = `รายการฝากทาง smile สั่งซื้อ ${normalOrders.length} รายการ\n${normalOrders.map(order => order.url).join('\n')}`;
        const sendOnlyText = `รายการฝากส่ง ${sendOnlyOrders.length} รายการ\n${sendOnlyOrders.map(order => `${order.smileNameInput} - ${order.trackingJp}`).join('\n')}`;
        textToCopy = `มีรายการของถึงทั้งหมด ${response.length} รายการ\n\n${normalText}\n\n${sendOnlyText}`;
      } else if (normalOrders.length > 0) {
        // Case: Only normal orders exist
        textToCopy = `มีรายการของถึงทั้งหมด ${normalOrders.length} รายการ\n${normalOrders.map(order => order.url).join('\n')}`;
      } else if (sendOnlyOrders.length > 0) {
        // Case: Only send-only orders exist
        textToCopy = `มีรายการของถึงทั้งหมด ${sendOnlyOrders.length} รายการ\n${sendOnlyOrders.map(order => `${order.smileNameInput} - ${order.trackingJp}`).join('\n')}`;
      }
      // Copy the text to clipboard
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          console.log('Text copied to clipboard');
          toast.success('Text copied!');
        })
        .catch(err => {
          console.error('Failed to copy text:', err);
          toast.error('Failed to copy text');
        });
      }
    }
    fetchData()
  }, [profileIdUrl])

  const handleSelectChange = async (e) => {
    const response = await getArrivalList({shipDateId: e.target.value})
    setPreRowData(response)

    const filteredShipDate = shipDates.filter(record => record.id == e.target.value)
    setShipDate(filteredShipDate)
    setShipDateId(e.target.value)
  }

  const handleAddDelayClick = async () => {
    if(!shipDate){
      toast.error("กรุณา เลือกรอบเรือก่อน")
    }else{
      console.log("FSD")
      const result = await addDelayArrival(shipDate[0].id)
      if(result){
        console.log(shipDate[0])
        setIsDelay(true)
        toast.success("Add Delay Success!!")
        const response = await getArrivalList({shipDateId: shipDate[0].id})
        setPreRowData(response)
      }else{
        toast.error("Add Delay Fail")
      }
    }
  }

  const handleArrivalClicked = async () => {
    setShowTotal(false)
    setSelectedState('wait')
    setIsArrival(true);
    const response = await getArrivalList({shipDateId: shipDate[0].id})
    setPreRowData(response)
    setColumnDefs([
      { headerName: 'Contact', field: 'contact', flex: 2 },
      { headerName: 'Channel', field: 'channel', flex: 1 },
      { field: 'Social ID (LINE)', cellRenderer: IconComponentSocialId, flex: 1 },
      { field: 'ลิ้งค์สินค้า', cellRenderer: IconComponentUrl, flex : 1},
      { field: 'action', cellRenderer: IconComponent, flex: 1 },
      { field: 'เลขกล่อง', cellRenderer: IconComponentBox, flex: 1 }
    ]);
  };
  
  const handleDelayClicked = async () => {
    setSelectedState('wait')
    setShowTotal(false)
    setIsArrival(false);
    const response = await getArrivalList({shipDateId: shipDate[0].id})
    setPreRowData(response)
    setColumnDefs([
      { headerName: 'Contact', field: 'contact', flex: 2 },
      { headerName: 'Channel', field: 'channel', flex: 1 },
      { field: 'Social ID (LINE)', cellRenderer: IconComponentSocialId, flex: 1 },
      { field: 'ลิ้งค์สินค้า', cellRenderer: IconComponentUrl, flex : 1},
      { field: 'action', cellRenderer: IconComponent, flex: 1 },
      { field: 'เลขกล่อง', cellRenderer: IconComponentBox, flex: 1 }
    ]);
  };
  
  const handleArrivalListClicked = async () => {
    setSelectedState('wait')
    if(showTotal){
      setShowTotal(false);
      const response = await getArrivalList({shipDateId: shipDate[0].id})
      setPreRowData(response)
      setColumnDefs([
        { headerName: 'Contact', field: 'contact', flex: 2 },
        { headerName: 'Channel', field: 'channel', flex: 1 },
        { field: 'Social ID (LINE)', cellRenderer: IconComponentSocialId, flex: 1 },
        { field: 'ลิ้งค์สินค้า', cellRenderer: IconComponentUrl, flex : 1},
        { field: 'action', cellRenderer: IconComponent, flex: 1 },
        { field: 'เลขกล่อง', cellRenderer: IconComponentBox, flex: 1 }
      ]);
    }  
  };
  
  const handleTotalClicked = async () => {
    setSelectedState('total')
    if(shipDate){
      setShowTotal(true);
      const response = await getArrivalList({shipDateId: shipDate[0].id})
      setPreRowData(response)
  
      setColumnDefs([
        { headerName: 'Contact', field: 'contact', flex: 2 },
        { headerName: 'Channel', field: 'channel', flex: 1 },
        { headerName: 'วันที่แจ้งลูกค้า', field: 'informDate', flex: 1 },
        { field: 'Social ID (LINE)', cellRenderer: IconComponentSocialId, flex: 1 },
        { field: 'ลิ้งค์สินค้า', cellRenderer: IconComponentUrl, flex : 1},
        { field: 'action', cellRenderer: IconComponentTotal, flex: 1 },
        { field: 'เลขกล่อง', cellRenderer: IconComponentBox, flex: 1 }
      ]);
    }
  };

  const handleAddressClick = async () => {
    setSelectedState('address')
    if(shipDate){
      const response = await getArrivalList({ shipDateId: shipDate[0].id });

      console.log(response)
      const formattedRecords = response.map(record => {
        return {
            ...record,
            contact: record.CustomerProfile ? record.CustomerProfile.contact : null,
            channel: record.CustomerProfile ? record.CustomerProfile.channel : null,
            sendSameAddress: record.CustomerProfile ? record.CustomerProfile.sendSameAddress : false
        };
      })
      // Filter the response
      const filteredResponse = formattedRecords.filter(record => 
        record.CustomerProfile.sendSameAddress === true && record.addressCopy === false
      );
      console.log(filteredResponse)

      // Set the filtered data to the state
      setRowData(filteredResponse);
  
      setColumnDefs([
        { headerName: 'Contact', field: 'contact', flex: 2 },
        { headerName: 'Channel', field: 'channel', flex: 1 },
        { field: 'Social ID (LINE)', cellRenderer: IconComponentSocialId, flex: 1 },
        { field: 'Action', cellRenderer: IconComponentAddress, flex: 1 }
      ]);
    }
  };

  const handleSendSameAddress = async () => {
    console.log(profile)
    if (!profile || !profile.customerId) {
      toast.error("ไม่พบข้อมูลลูกค้า");
      return;
    }
    
    // Toggle sendSameAddress: if currently true, set to false; if false, set to true
    const newValue = !sendSameAddress;
    
    const response = await updateSendSameAddress({
      ...profile,
      sendSameAddress: newValue
    })
    if(response){
      setSendSameAddress(newValue)
      
      // Update row data in place to maintain scroll position
      setRowData(prevRowData => {
        return prevRowData.map(record => {
          if (record.CustomerProfile && record.CustomerProfile.id === profile.customerId) {
            return {
              ...record,
              CustomerProfile: {
                ...record.CustomerProfile,
                sendSameAddress: newValue
              },
              sendSameAddress: newValue
            };
          }
          return record;
        });
      });
      
      // Also update preRowData to keep it in sync
      setPreRowData(prevPreRowData => {
        return prevPreRowData.map(record => {
          if (record.CustomerProfile && record.CustomerProfile.id === profile.customerId) {
            return {
              ...record,
              CustomerProfile: {
                ...record.CustomerProfile,
                sendSameAddress: newValue
              }
            };
          }
          return record;
        });
      });
      
      toast.success(`อัพเดทสำเร็จ: ${newValue ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} ส่งที่เดิมตลอด`)
    }else{
      toast.error("มีบางอย่างผิดพลาด")
    }
  };

  const handleSocialIdClick = (customerId, existingSocialId) => {
    setCurrentCustomerId(customerId);
    setCurrentSocialId(existingSocialId || '');
    setSocialIdDialogOpen(true);
  };

  const handleSocialIdDialogClose = () => {
    setSocialIdDialogOpen(false);
    setCurrentSocialId('');
    setCurrentCustomerId(null);
  };

  const handleSocialIdSave = async () => {
    if (!currentCustomerId) return;
    
    const result = await updateSocialId({
      customerId: currentCustomerId,
      socialId: currentSocialId.trim()
    });
    
    if (result) {
      toast.success("อัพเดท Social ID สำเร็จ");
      // Update the row data in place instead of full refresh to maintain scroll position
      setRowData(prevRowData => {
        return prevRowData.map(record => {
          if (record.CustomerProfile && record.CustomerProfile.id === currentCustomerId) {
            return {
              ...record,
              CustomerProfile: {
                ...record.CustomerProfile,
                socialId: currentSocialId.trim() || null
              },
              socialId: currentSocialId.trim() || null
            };
          }
          return record;
        });
      });
      // Also update preRowData to keep it in sync
      setPreRowData(prevPreRowData => {
        return prevPreRowData.map(record => {
          if (record.CustomerProfile && record.CustomerProfile.id === currentCustomerId) {
            return {
              ...record,
              CustomerProfile: {
                ...record.CustomerProfile,
                socialId: currentSocialId.trim() || null
              }
            };
          }
          return record;
        });
      });
      handleSocialIdDialogClose();
    } else {
      toast.error("มีบางอย่างผิดพลาด");
    }
  };

  const [notificationError, setNotificationError] = useState(null);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  
  // Test send states
  const [selectedTestUser, setSelectedTestUser] = useState('');
  const [isSendingTest, setIsSendingTest] = useState(false);

  const handleOpenPreview = async () => {
    if (!shipDate || shipDate.length === 0) {
      toast.error("กรุณาเลือกรอบเรือก่อน");
      return;
    }

    // Filter to only white (priority 1) and yellow (priority 2) rows
    const eligibleRows = rowData.filter(record => {
      const priority = getSortPriority(record);
      return priority === 1 || priority === 2; // Only white and yellow
    });

    // Exclude customers with sendSameAddress (they don't need auto notifications)
    const rowsWithoutSendSameAddress = eligibleRows.filter(record => 
      !record.CustomerProfile || !record.CustomerProfile.sendSameAddress
    );

    // Exclude Facebook customers (Chatcone only supports LINE)
    const rowsWithoutFacebook = rowsWithoutSendSameAddress.filter(record => {
      const channel = record.CustomerProfile?.channel;
      return !channel || channel.toLowerCase() !== 'facebook';
    });

    // Filter to only rows with socialId
    const rowsWithSocialId = rowsWithoutFacebook.filter(record => 
      record.CustomerProfile && record.CustomerProfile.socialId
    );

    if (rowsWithSocialId.length === 0) {
      toast.error("ไม่พบรายการที่มี Social ID หรือไม่สามารถส่งได้ (เฉพาะสีขาวและเหลือง)");
      return;
    }

    // Take first 10
    const selectedRows = rowsWithSocialId.slice(0, 10);
    const customerIds = selectedRows.map(row => row.CustomerProfile.id);

    setIsLoadingPreview(true);
    try {
      // Get preview data (dates and customers)
      const previewResult = await getArrivalPreview({
        customerIds: customerIds,
        shipDateId: shipDate[0].id
      });

      if (previewResult) {
        setPreviewData({
          ...previewResult,
          selectedRows: selectedRows
        });
        setPreviewModalOpen(true);
      }
    } catch (error) {
      toast.error("ไม่สามารถโหลดข้อมูลสำหรับตรวจสอบได้");
      console.error(error);
    } finally {
      setIsLoadingPreview(false);
    }
  };

  const handleClosePreview = () => {
    setPreviewModalOpen(false);
    setPreviewData(null);
  };

  const handleSendBatchNotifications = async () => {
    // Clear previous error
    setNotificationError(null);

    if (!previewData || !previewData.selectedRows) {
      toast.error("ไม่พบข้อมูลสำหรับส่งแจ้งเตือน");
      return;
    }

    if (!shipDate || shipDate.length === 0) {
      toast.error("กรุณาเลือกรอบเรือก่อน");
      return;
    }

    const selectedRows = previewData.selectedRows;
    const customerIds = selectedRows.map(row => row.CustomerProfile.id);

    // Send notifications - template is stored in Chatcone, identified by message_id
    try {
      const result = await sendArrivalNotifications({
        customerIds: customerIds,
        shipDateId: shipDate[0].id
      });

      // Close preview modal after send (whether success or fail)
      handleClosePreview();

      if (result && result.success) {
        // Update informDate only for successfully notified customers
        if (result.successfulCustomerIds && result.successfulCustomerIds.length > 0) {
          // Filter selectedRows to only include successful customers
          const successfulRows = selectedRows.filter(row => 
            result.successfulCustomerIds.includes(row.CustomerProfile.id)
          );
          
          // Update informDate for successful customers only
          const updatePromises = successfulRows.map(row => 
            arrivalInform({ arrivalId: row.id, isAutoInformed: true })
          );
          
          await Promise.all(updatePromises);
        }
        
        if (result.totalFailed > 0) {
          // Partial success - show warning message with details
          setNotificationError(result.message || `ส่งแจ้งเตือนสำเร็จ ${result.totalSent} คน แต่มี ${result.totalFailed} คนที่ส่งไม่สำเร็จ`);
          toast.warning(`ส่งแจ้งเตือนสำเร็จ ${result.totalSent} คน แต่มี ${result.totalFailed} คนที่ส่งไม่สำเร็จ`);
        } else {
          // Full success
          toast.success(`ส่งแจ้งเตือนสำเร็จ ${result.totalSent} คน`);
          setNotificationError(null); // Clear error on success
        }
        
        // Refresh the data
        const response = await getArrivalList({shipDateId: shipDate[0].id});
        setPreRowData(response);
      } else {
        // Complete failure - don't update informDate
        const errorMsg = "ส่งแจ้งเตือนไม่สำเร็จ";
        setNotificationError(errorMsg);
        toast.error(errorMsg);
      }
    } catch (error) {
      // Close preview modal on error
      handleClosePreview();
      // Display the error message from the backend (already in Thai)
      const errorMessage = error.message || "ส่งแจ้งเตือนไม่สำเร็จ";
      setNotificationError(errorMessage);
      toast.error(errorMessage);
    }
  };

  // Test send functions
  const handleTestUserChange = (event) => {
    setSelectedTestUser(event.target.value);
  };

  const handleFireTestSend = async () => {
    // Early validation checks - these should match the disabled condition
    if (!shipDate || shipDate.length === 0) {
      toast.error("กรุณาเลือกรอบเรือก่อน");
      return;
    }

    if (!selectedTestUser) {
      toast.error("กรุณาเลือกผู้รับทดสอบก่อน");
      return;
    }

    if (!customerData || !customerData.CustomerProfile || !customerData.CustomerProfile.id) {
      toast.error("กรุณาเลือกลูกค้าจากรายการก่อน");
      return;
    }

    setIsSendingTest(true);
    try {
      const result = await sendTestArrivalNotification({
        testSocialId: selectedTestUser,
        customerId: customerData.CustomerProfile.id,
        shipDateId: shipDate[0].id
      });

      if (result && result.success) {
        toast.success("🔥 ส่งทดสอบสำเร็จ!");
      } else {
        toast.error("ส่งทดสอบไม่สำเร็จ");
      }
    } catch (error) {
      const errorMessage = error.message || "ส่งทดสอบไม่สำเร็จ";
      toast.error(errorMessage);
    } finally {
      setIsSendingTest(false);
    }
  };

  // Get filtered test users by shop
  const filteredTestUsers = TEST_USERS.filter(user => user.shop === shopName);

  useEffect(() => {
    if(preRowData.length > 0){
      const formattedRecords = preRowData.map(record => {
        return {
            ...record,
            contact: record.CustomerProfile ? record.CustomerProfile.contact : null,
            channel: record.CustomerProfile ? record.CustomerProfile.channel : null,
            needDown: record.CustomerProfile ? record.CustomerProfile.needDown : null,
            needCurrent: record.CustomerProfile ? record.CustomerProfile.needCurrent : null,
            oldNotPaid: record.CustomerProfile ? record.CustomerProfile.oldNotPaid : null,
            informDate: formatDate(record.informDate),
            socialId: record.CustomerProfile ? record.CustomerProfile.socialId : null,
            sendSameAddress: record.CustomerProfile ? record.CustomerProfile.sendSameAddress : false
        };
    });
      let filteredRecords;
      if(isArrival){
        if(!showTotal){
          filteredRecords = formattedRecords.filter(record => record.informDate == '' && record.type === 'ของถึง');
        }else{
          filteredRecords = formattedRecords.filter(record => record.type === 'ของถึง');
        }
      }else{
        if(!showTotal){
          filteredRecords = formattedRecords.filter(record => record.informDate == '' && record.type !== 'ของถึง');
        }else{
          filteredRecords = formattedRecords.filter(record => record.type !== 'ของถึง');
        }
      }
      
      // Sort by priority: white first, then yellow/orange, then red
      const sortedRecords = sortRecordsByPriority(filteredRecords);
      setRowData(sortedRecords);

      //เช็คว่า มี delay ไหม หรือ มีแค่ แจ้งของถึง
      const hasDelay = preRowData.some(item => item.type === 'delay');
      setIsDelay(hasDelay)
    }
  },[preRowData, isArrival, showTotal])

  useEffect(() => {
    getShipDates()
  },[])

  return (
    <div className="ag-theme-alpine mx-auto" style={{ width: '100%' }}>
      <h2>แจ้งของถึง</h2>
      <div className='flex justify-between'>
        <div className='flex'>
          <ShipDateDropdown 
            handleDataChange={handleSelectChange}
            includeDefault={true}
          />
          {isLoading && <CircularProgress />} {/* Render spinner when loading */}
          <div className="flex justify-center">
            <button 
              className={`ml-3 text-base font-bold btn ${isArrival ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
              onClick={handleArrivalClicked}
              style={{ transition: 'all 0.3s ease' }}>
              ของถึง
            </button>
            { isDelay && <button 
                className={`font-bold btn ${!isArrival ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
                onClick={handleDelayClicked}
                style={{ transition: 'all 0.3s ease' }}>
                แจ้งรอบเรือ Delay
              </button>
            }
          </div>
        </div>

        { user.role === 'superuser' && !isDelay && <button className='btn-success' onClick={handleAddDelayClick}>
            แจ้งรอบเรือ Delay
          </button>
        }
      </div>
      <div className='grid grid-cols-5 gap-x-3'>
        <div className='col-span-2'>
          <div className='flex mt-3'>
            <button 
              className={`text-base font-bold btn ${selectedState == 'wait' ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
              onClick={handleArrivalListClicked}
              style={{ transition: 'all 0.3s ease' }}>
              รายการรอแจ้ง
            </button>
            <button 
              className={`text-base font-bold btn ${selectedState == 'total' ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
              onClick={handleTotalClicked}
              style={{ transition: 'all 0.3s ease' }}>
              รายการทั้งหมด
            </button>
            <button 
              className={`text-base font-bold btn ${selectedState == 'address' ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'} w-32 cursor-pointer hover:bg-blue-400 hover:text-white`}
              onClick={handleAddressClick}
              style={{ transition: 'all 0.3s ease' }}>
              มีที่อยู่แล้ว
            </button>
            {selectedState === 'wait' && (
              <button 
                className="text-base font-bold btn bg-green-500 text-white w-40 cursor-pointer hover:bg-green-400 hover:text-white ml-3"
                onClick={handleOpenPreview}
                style={{ transition: 'all 0.3s ease' }}
                disabled={isLoading || isLoadingPreview}>
                {isLoadingPreview ? 'กำลังโหลด...' : 'ตรวจสอบก่อนส่ง (10 คน)'}
              </button>
            )}
            {/* Test Send Section */}
            {selectedState === 'wait' && filteredTestUsers.length > 0 && (
              <div className="flex items-center ml-3">
                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel id="test-user-label">ผู้รับทดสอบ</InputLabel>
                  <Select
                    labelId="test-user-label"
                    value={selectedTestUser}
                    label="ผู้รับทดสอบ"
                    onChange={handleTestUserChange}
                  >
                    {filteredTestUsers.map((user) => (
                      <MenuItem key={user.socialId} value={user.socialId}>
                        {user.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <button 
                  className="text-base font-bold btn bg-red-500 text-white w-24 cursor-pointer hover:bg-red-400 hover:text-white ml-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleFireTestSend}
                  style={{ transition: 'all 0.3s ease' }}
                  disabled={isSendingTest || !selectedTestUser || !customerData?.CustomerProfile?.id}>
                  {isSendingTest ? '🔥...' : 'TEST'}
                </button>
              </div>
            )}
          </div>
          {notificationError && (
            <div className="mt-3 mb-3">
              <Alert 
                severity={notificationError.includes('สำเร็จ') ? "warning" : "error"} 
                onClose={() => setNotificationError(null)}
                sx={{ whiteSpace: 'pre-wrap' }}
              >
                <AlertTitle>{notificationError.includes('สำเร็จ') ? "แจ้งเตือน" : "เกิดข้อผิดพลาด"}</AlertTitle>
                {notificationError}
              </Alert>
            </div>
          )}
          <div style={{ height: '80vh'}}>
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columnDefs}
              rowData={rowData}
              defaultColDef={{ resizable: true }}
              getRowStyle={(params) => {
                // Priority: sendSameAddress first (most visible), then payment status
                if (params.data.sendSameAddress) {
                  return highlightSendSameAddress;
                }
                if (params.data.needDown) {
                  return highlightNeedDown;
                }
                if (params.data.needCurrent) {
                  return highlightNeedCurrent;
                }
                if (params.data.oldNotPaid) {
                  return highlightOldNotPaid;
                }
                return {};
              }}
              
              
              // other props
            />
          </div>
        </div>
        <div className='col-span-3 mt-7'>
          <div>
            { profile && (
              <div className='flex justify-between items-center'>
              <div>
                <p className={`text-2xl ${sendSameAddress && 'bg-green-200 px-3 py-1 rounded'}`}>
                  {profile?.contact}
                </p>
              </div>
              <button 
                className={`mb-2 ${sendSameAddress ? 'btn-success' : 'btn-primary'}`} 
                onClick={handleSendSameAddress}
              >
                {sendSameAddress ? 'ปิดการส่งที่เดิมตลอด' : 'เปิดการส่งที่เดิมตลอด'}
              </button>
            </div>
            )}
            {orders && orders.length > 0 && (
              <OrderSummaryTable 
                smileName={profile?.contact || ""}
                orders={orders}
                orderSummary={orderSummary}
                isAdmin={false}
              />
            )}
          </div>
        </div>
      </div>

      {/* Social ID Dialog */}
      <Dialog open={socialIdDialogOpen} onClose={handleSocialIdDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>แก้ไข Social ID</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Social ID"
            fullWidth
            variant="outlined"
            value={currentSocialId}
            onChange={(e) => setCurrentSocialId(e.target.value)}
            helperText="กรอก Social ID (เช่น LINE User ID) หรือเว้นว่างเพื่อลบ"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSocialIdDialogClose}>ยกเลิก</Button>
          <Button onClick={handleSocialIdSave} variant="contained" color="primary">
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>

      {/* Preview Modal */}
      <Dialog 
        open={previewModalOpen} 
        onClose={handleClosePreview} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          sx: { maxHeight: '90vh' }
        }}
      >
        <DialogTitle>ตรวจสอบข้อมูลก่อนส่งแจ้งเตือน</DialogTitle>
        <DialogContent>
          {previewData && (
            <Box sx={{ mt: 2 }}>
              {/* Message Preview Section */}
              <Typography variant="h6" gutterBottom>
                ข้อมูลที่จะส่ง:
              </Typography>
              
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>รอบเรือ:</strong> {previewData.shipDate || 'ไม่ระบุ'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>วันที่รับของที่คลัง:</strong> {previewData.pickupDate || 'ไม่ระบุ'}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>วันที่ส่งของ:</strong> {previewData.deliveryDate || 'ไม่ระบุ'}
                </Typography>
                {previewData.paymentDueDate && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>วันที่ชำระเงินสุดท้าย:</strong> {previewData.paymentDueDate}
                  </Typography>
                )}
                {previewData.addressChangeDeadlineDate && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>วันสุดท้ายในการเปลี่ยนที่อยู่:</strong> {previewData.addressChangeDeadlineDate}
                  </Typography>
                )}
                <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                  * ข้อความจะถูกส่งผ่านระบบ Chatcone โดยใช้ template ที่กำหนดไว้
                </Typography>
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* Customer List Section */}
              <Typography variant="h6" gutterBottom>
                รายชื่อลูกค้าที่จะได้รับแจ้งเตือน ({previewData.totalCustomers} คน):
              </Typography>
              
              <List sx={{ bgcolor: '#fafafa', borderRadius: 1, py: 0 }}>
                {previewData.customers && previewData.customers.map((customer, index) => (
                  <ListItem 
                    key={customer.id} 
                    divider={index < previewData.customers.length - 1}
                    sx={{ py: 1.5 }}
                  >
                    <ListItemText
                      primary={`${index + 1}. ${customer.contact}`}
                      primaryTypographyProps={{ fontSize: '0.95rem' }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePreview}>
            ยกเลิก
          </Button>
          <Button 
            onClick={handleSendBatchNotifications} 
            variant="contained" 
            color="primary"
            disabled={isLoading}
          >
            {isLoading ? 'กำลังส่ง...' : 'ส่งแจ้งเตือน'}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default Arrival;
